import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.modules');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-support-modules',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.support.modules/view.scss */
:host {
  display: block;
}`],
})
export class PortalLpsysadminSupportModulesComponent implements OnInit {
    public templates: any[] = [];
    public loaded: boolean = false;
    public selectedType: string = '';
    public form: any = null;          // 편집 중인 템플릿 사본
    public original: any = null;      // 원본 (변경 비교용)
    public saving: boolean = false;

    public showGlobal: boolean = false;
    public template: any = { scale: 7, categories: [] };
    public templateSaving: boolean = false;
    public xlsxImporting: boolean = false;
    public scaleOptions: number[] = [3, 4, 5, 6, 7, 8, 9, 10];

    public typeMeta: any = {
        recruitment:   { label: '모집공고',     icon: '📢', color: 'bg-zinc-100 text-zinc-700' },
        selection:     { label: '선발',         icon: '🎯', color: 'bg-amber-100 text-amber-700' },
        kickoff:       { label: '킥오프',       icon: '🚩', color: 'bg-orange-100 text-orange-700' },
        diagnosis:     { label: '진단',         icon: '📊', color: 'bg-emerald-100 text-emerald-700' },
        education:     { label: '교육',         icon: '🎓', color: 'bg-blue-100 text-blue-700' },
        workshop:      { label: '워크숍',       icon: '🛠️', color: 'bg-cyan-100 text-cyan-700' },
        mentoring:     { label: '멘토링',       icon: '🤝', color: 'bg-violet-100 text-violet-700' },
        networking:    { label: '네트워킹',     icon: '🌐', color: 'bg-pink-100 text-pink-700' },
        site_visit:    { label: '현장방문',     icon: '🚗', color: 'bg-lime-100 text-lime-700' },
        ir_pitching:   { label: 'IR 피칭',      icon: '🎤', color: 'bg-fuchsia-100 text-fuchsia-700' },
        demoday:       { label: '데모데이',     icon: '🚀', color: 'bg-rose-100 text-rose-700' },
        funding_match: { label: '투자매칭',     icon: '💰', color: 'bg-yellow-100 text-yellow-800' },
        expense_mgmt:  { label: '예산집행',     icon: '🧾', color: 'bg-teal-100 text-teal-700' },
        survey:        { label: '만족도조사',   icon: '📝', color: 'bg-slate-100 text-slate-700' },
        company_mgmt:  { label: '기업관리',     icon: '🏢', color: 'bg-sky-100 text-sky-700' },
        follow_up:     { label: '사후관리',     icon: '🔁', color: 'bg-stone-100 text-stone-700' },
        reporting:     { label: '보고',         icon: '📑', color: 'bg-zinc-200 text-zinc-700' },
    };

    // 일반 모듈용 단순 필드 스키마 (선발은 별도 UI 사용)
    public fieldSchemas: any = {
        recruitment: [
            { key: 'apply_url', label: '신청 URL', type: 'text', placeholder: 'https://' },
            { key: 'recruit_count', label: '모집 인원', type: 'number' },
            { key: 'recruit_method', label: '모집 방식', type: 'select', options: ['상시', '공고'] },
            { key: 'eligibility', label: '신청 자격', type: 'textarea' },
            { key: 'application_form', label: '신청서 양식 안내', type: 'textarea' },
        ],
        kickoff: [
            { key: 'venue', label: '장소', type: 'text' },
            { key: 'agenda', label: '주요 안건', type: 'textarea' },
            { key: 'attendance_required', label: '참석 필수', type: 'select', options: ['예', '아니오'] },
        ],
        diagnosis: [
            { key: 'cycle', label: '진단 주기', type: 'select', options: ['1회', '월간', '분기', '반기'] },
            { key: 'mandatory', label: '필수 여부', type: 'select', options: ['필수', '선택'] },
            { key: 'use_global_template', label: '전역 템플릿 사용', type: 'select', options: ['예', '아니오'] },
        ],
        education: [
            { key: 'instructor', label: '강사', type: 'text' },
            { key: 'curriculum', label: '교육 과정', type: 'textarea' },
            { key: 'session_count', label: '회차 수', type: 'number' },
            { key: 'hours_per_session', label: '회차당 시간(h)', type: 'number' },
            { key: 'attendance_required', label: '출석 필수', type: 'select', options: ['예', '아니오'] },
        ],
        workshop: [
            { key: 'topic', label: '주제', type: 'text' },
            { key: 'facilitator', label: '진행자', type: 'text' },
            { key: 'materials', label: '준비물/자료', type: 'textarea' },
        ],
        mentoring: [
            { key: 'mentor_pool', label: '멘토 풀(쉼표 구분)', type: 'text' },
            { key: 'session_minutes', label: '세션 시간(분)', type: 'number' },
            { key: 'total_sessions', label: '총 세션 수', type: 'number' },
            { key: 'topics', label: '주요 주제', type: 'textarea' },
            { key: 'match_method', label: '매칭 방식', type: 'select', options: ['지정', '신청', '추천'] },
        ],
        networking: [
            { key: 'invitee_target', label: '대상 (예: VC/CVC)', type: 'text' },
            { key: 'expected_count', label: '예상 참석자 수', type: 'number' },
        ],
        site_visit: [
            { key: 'destination', label: '방문지', type: 'text' },
            { key: 'transport', label: '교통편', type: 'text' },
            { key: 'agenda', label: '방문 일정', type: 'textarea' },
        ],
        ir_pitching: [
            { key: 'audience', label: '대상 투자자', type: 'text' },
            { key: 'pitch_minutes', label: '발표 시간(분)', type: 'number' },
            { key: 'qna_minutes', label: 'Q&A 시간(분)', type: 'number' },
        ],
        demoday: [
            { key: 'venue', label: '장소', type: 'text' },
            { key: 'audience', label: '청중', type: 'text' },
            { key: 'pitch_minutes', label: '팀당 발표 시간(분)', type: 'number' },
            { key: 'awards', label: '시상 내역', type: 'textarea' },
        ],
        funding_match: [
            { key: 'investor_pool', label: '투자자 풀', type: 'textarea' },
            { key: 'target_amount', label: '목표 매칭 금액(억)', type: 'number' },
        ],

        expense_mgmt: [
            { key: 'budget_total', label: '총 예산(만원)', type: 'number' },
            { key: 'categories', label: '집행 항목(쉼표 구분)', type: 'text' },
            { key: 'approval_required', label: '결재 필요', type: 'select', options: ['예', '아니오'] },
        ],
        survey: [
            { key: 'cycle', label: '조사 시점', type: 'select', options: ['중간', '종료', '중간+종료', '회차별'] },
            { key: 'anonymous', label: '익명 여부', type: 'select', options: ['익명', '실명'] },
        ],
        company_mgmt: [
            { key: 'pm', label: '담당 PM', type: 'text' },
            { key: 'meeting_cycle', label: '미팅 주기', type: 'select', options: ['주간', '격주', '월간', '분기'] },
        ],
        follow_up: [
            { key: 'duration_months', label: '관리 기간(월)', type: 'number' },
            { key: 'metrics', label: '추적 지표', type: 'textarea' },
        ],
        reporting: [
            { key: 'cycle', label: '보고 주기', type: 'select', options: ['주간', '월간', '분기', '연간'] },
            { key: 'report_to', label: '제출처', type: 'text' },
        ],
    };

    public targetAudienceOptions: string[] = ['전원', '추천만', '사전선별', '서류통과자'];
    public formatOptions: string[] = ['대면', '비대면', '하이브리드'];

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public typeLabel(t: string) { return this.typeMeta[t]?.label || t; }
    public typeIcon(t: string) { return this.typeMeta[t]?.icon || '📦'; }
    public typeColor(t: string) { return this.typeMeta[t]?.color || 'bg-zinc-100 text-zinc-700'; }
    public schemaFor(t: string): any[] { return this.fieldSchemas[t] || []; }

    public async load() {
        this.loaded = false;
        const res = await wiz.call('list', {});
        if (res.code === 200) {
            this.templates = res.data.templates || [];
        }
        this.loaded = true;
        // 첫 진입 시 첫 번째 항목 자동 선택
        if (!this.selectedType && this.templates.length > 0) {
            this.select(this.templates[0]);
        } else if (this.selectedType) {
            const cur = this.templates.find((t: any) => t.module_type === this.selectedType);
            if (cur) this.select(cur);
        }
        await this.service.render();
    }

    public select(t: any) {
        this.selectedType = t.module_type;
        // deep clone
        this.original = JSON.parse(JSON.stringify(t));
        this.form = JSON.parse(JSON.stringify(t));
        if (!this.form.config) this.form.config = {};
        if (this.form.module_type === 'selection') this.ensureSelectionShape();
    }

    public isDirty(): boolean {
        if (!this.form || !this.original) return false;
        return JSON.stringify(this.form) !== JSON.stringify(this.original);
    }

    public async save() {
        if (!this.form) return;
        this.saving = true;
        const res = await wiz.call('save', {
            module_type: this.form.module_type,
            title: this.form.title || '',
            description: this.form.description || '',
            default_status: this.form.default_status || 'active',
            config: JSON.stringify(this.form.config || {}),
        });
        this.saving = false;
        if (res.code === 200) {
            await this.service.alert.show({ title: '저장 완료', message: '템플릿을 저장했습니다.', action: '확인', actionBtn: 'success' });
            await this.load();
        } else {
            await this.service.alert.show({ title: '저장 실패', message: res.data?.message || '오류', action: '확인', actionBtn: 'error' });
        }
    }

    public async resetTemplate() {
        if (!this.form) return;
        const ok = await this.service.alert.show({
            title: '기본값 초기화',
            message: `"${this.typeLabel(this.form.module_type)}" 템플릿을 시스템 기본값으로 되돌립니다. 진행하시겠습니까?`,
            action: '초기화', actionBtn: 'error', cancel: '취소',
        });
        if (!ok) return;
        const res = await wiz.call('reset', { module_type: this.form.module_type });
        if (res.code === 200) {
            await this.service.alert.show({ title: '완료', message: '기본값으로 초기화되었습니다.', action: '확인', actionBtn: 'success' });
            await this.load();
        } else {
            await this.service.alert.show({ title: '실패', message: res.data?.message || '오류', action: '확인', actionBtn: 'error' });
        }
    }

    public async cancelEdit() {
        if (!this.original) return;
        this.form = JSON.parse(JSON.stringify(this.original));
        await this.service.render();
    }

    // ============ 선발 모듈 전용 (서류/발표 평가) ============
    public ensureSelectionShape() {
        if (!this.form || this.form.module_type !== 'selection') return;
        const c = this.form.config || (this.form.config = {});
        if (typeof c.select_count !== 'number') c.select_count = 0;
        if (typeof c.weight_paper !== 'number') c.weight_paper = 70;
        if (typeof c.weight_present !== 'number') c.weight_present = 30;
        if (typeof c.publish_results !== 'boolean') c.publish_results = false;
        if (!c.paper_eval) c.paper_eval = { enabled: true, target_audience: '전원', evaluators_count: 3, total_score: 100, pass_score: 60, items: [] };
        if (!c.presentation_eval) c.presentation_eval = { enabled: true, target_audience: '서류통과자', format: '대면', duration_min: 10, qna_min: 5, evaluators_count: 3, total_score: 100, pass_score: 60, items: [] };
        if (!Array.isArray(c.paper_eval.items)) c.paper_eval.items = [];
        if (!Array.isArray(c.presentation_eval.items)) c.presentation_eval.items = [];
    }

    public addEvalItem(stage: 'paper_eval' | 'presentation_eval') {
        this.ensureSelectionShape();
        this.form.config[stage].items.push({ label: '', score: 0 });
    }
    public removeEvalItem(stage: 'paper_eval' | 'presentation_eval', i: number) {
        this.form.config[stage].items.splice(i, 1);
    }
    public sumEval(stage: 'paper_eval' | 'presentation_eval'): number {
        const items = this.form?.config?.[stage]?.items || [];
        return items.reduce((s: number, it: any) => s + (Number(it.score) || 0), 0);
    }

    // ============ 전역 진단 템플릿 (모달) ============
    public async openGlobal() {
        this.showGlobal = true;
        const res = await wiz.call('global_template', {});
        if (res.code === 200) {
            this.template = res.data.data || { scale: 7, categories: [] };
            if (!this.template.categories) this.template.categories = [];
        }
        await this.service.render();
    }

    public closeGlobal() { this.showGlobal = false; }

    public addGlobalCategory() {
        this.template.categories.push({ key: 'cat' + (this.template.categories.length + 1), label: '새 카테고리', items: [{ q: '새 질문' }] });
    }
    public removeGlobalCategory(i: number) { this.template.categories.splice(i, 1); }
    public addGlobalItem(ci: number) { this.template.categories[ci].items.push({ q: '' }); }
    public removeGlobalItem(ci: number, qi: number) { this.template.categories[ci].items.splice(qi, 1); }

    public async saveGlobal() {
        this.templateSaving = true;
        const res = await wiz.call('save_global_template', { data: JSON.stringify(this.template) });
        this.templateSaving = false;
        if (res.code === 200) {
            await this.service.alert.show({ title: '저장 완료', message: '전역 진단 템플릿을 저장했습니다.', action: '확인', actionBtn: 'success' });
        } else {
            await this.service.alert.show({ title: '저장 실패', message: res.data?.message || '오류', action: '확인', actionBtn: 'error' });
        }
    }

    public async applyGlobalToAll(overwrite: boolean) {
        const ok = await this.service.alert.show({
            title: '전체 적용',
            message: overwrite
                ? '⚠️ 모든 진단 모듈의 질문지를 전역 템플릿으로 덮어씁니다. 기존 사용자 정의 질문이 사라집니다. 계속하시겠습니까?'
                : '질문지가 비어있는 진단 모듈에만 전역 템플릿을 적용합니다. 계속하시겠습니까?',
            action: '적용', actionBtn: overwrite ? 'error' : 'success',
            cancel: '취소',
        });
        if (!ok) return;
        const res = await wiz.call('apply_global', { overwrite: overwrite ? 'true' : 'false' });
        if (res.code === 200) {
            await this.service.alert.show({ title: '적용 완료', message: `${res.data.applied}개 모듈에 적용되었습니다.`, action: '확인', actionBtn: 'success' });
        } else {
            await this.service.alert.show({ title: '실패', message: res.data?.message || '오류', action: '확인', actionBtn: 'error' });
        }
    }

    public async onXlsxSelected(ev: any) {
        const file: File = ev?.target?.files?.[0];
        ev.target.value = '';
        if (!file) return;
        const ok = await this.service.alert.show({
            title: '엑셀 불러오기',
            message: `"${file.name}" 을(를) 읽어 현재 질문지를 교체합니다.\n(저장 버튼을 눌러야 적용됩니다)`,
            action: '진행', actionBtn: 'success', cancel: '취소'
        });
        if (!ok) return;
        this.xlsxImporting = true;
        try {
            const fd = new FormData();
            fd.append('file', file);
            fd.append('scale', String(this.template.scale || 7));
            const res = await fetch(`/wiz/api/portal.lpsysadmin.support.modules/import_xlsx`, {
                method: 'POST', body: fd, credentials: 'include',
            });
            const json = await res.json();
            if (res.ok && json?.data?.data) {
                const parsed = json.data.data;
                this.template = parsed;
                if (!this.template.categories) this.template.categories = [];
                await this.service.alert.show({
                    title: '불러오기 완료',
                    message: `카테고리 ${parsed.categories.length}개, 총 ${parsed.categories.reduce((s:number,c:any)=>s+c.items.length,0)}개 질문을 인식했습니다.`,
                    action: '확인', actionBtn: 'success'
                });
            } else {
                await this.service.alert.show({ title: '불러오기 실패', message: json?.data?.message || '엑셀 파싱 오류', action: '확인', actionBtn: 'error' });
            }
        } catch (e: any) {
            await this.service.alert.show({ title: '불러오기 실패', message: e?.message || '네트워크 오류', action: '확인', actionBtn: 'error' });
        }
        this.xlsxImporting = false;
        await this.service.render();
    }
}

export default PortalLpsysadminSupportModulesComponent;